<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">SJL担当者編集</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                return-object
                url="divisions/kv?type=BU"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="事業部"
                return-object
                url="divisions/kv?type=DEPARTMENT"
                v-model="query.department"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="SJL輸入営業"
                return-object
                url="employees/kv"
                v-model="query.importDirector"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="SJL輸入推進"
                return-object
                url="employees/kv"
                v-model="query.promoteDirector"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId', 'sjl', 'accRepeat'],
  data() {
    return {
      query: {},
      show: false,
      buUrl: `divisions/kv?type=BU&companyId=${this.companyId}`,
      departmentUrl: `divisions/kv?type=DEPARTMENT&companyId=${this.companyId}`
    }
  },
  methods: {
    popup(id, accId) {
      this.$http.get(`/companies/${id}/accs/${accId}`).then(res => {
        this.acc = res.data
        this.initData()
        this.show = true
      })
    },
    save() {
      if (this.accRepeat(this.query)) return
      this.$http
        .put(`/companies/${this.sjl.id}/edit-sjl-acc`, {
          buId: this.getValue(this.query.bu),
          departmentId: this.getValue(this.query.department),
          importDirectorId: this.getValue(this.query.importDirector),
          promoteDirectorId: this.getValue(this.query.promoteDirector)
        })
        .then(() => {
          this.$emit('refresh')
          this.show = false
        })
    },
    getValue(data) {
      return data && data.value
    },
    back() {
      this.query = {}
      this.show = false
    },
    initData() {
      this.$set(this.query, 'bu', {
        text: this.sjl.buName,
        value: this.sjl.buId
      })
      this.$set(this.query, 'department', {
        text: this.sjl.departmentName,
        value: this.sjl.departmentId
      })
      this.$set(this.query, 'importDirector', {
        text: this.sjl.importDirectorName,
        value: this.sjl.importDirectorId
      })
      this.$set(this.query, 'promoteDirector', {
        text: this.sjl.promoteDirectorName,
        value: this.sjl.promoteDirectorId
      })
    }
  }
}
</script>
